import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Alert } from '@mui/material';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { fDate } from 'src/utils/formatTime';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();

  useEffect(() => {
    if (user?.subscription?.type === 'paid' && user?.subscription?.days_remaining <= 4) {
      setShowAlert(true);
    } else if (user?.subscription?.type === 'trail') {
      setShowAlert(true);
    } else if (user?.subscription?.type === 'canceled') {
      setShowAlert(true);
    } else if (user?.subscription?.type === 'expired') {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  }, [user?.subscription?.type, location.pathname]);

  const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
      // paddingTop: APP_BAR_DESKTOP + 5,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  }));

  return (
    <>
      <RootStyle>
        <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
        <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        <MainStyle>
          <Alert
            severity="error"
            sx={{
              display: !showAlert ? 'none' : 'flex',
              // display: user?.subscription?.type === 'trail' ? 'flex' : 'none',
              borderRadius: 0,
              position: 'fixed',
              width: '100%',
              zIndex: 1099,
              top: { xs: APP_BAR_MOBILE, lg: 0 },
              left: 0,
              marginLeft: { xs: 0, lg: '250px' },
              backgroundColor: 'error.lighter'
            }}
          >
            {user?.subscription?.type === 'trail'
              ? `Your free trial period is ending on (${fDate(
                  user?.subscription?.end_date
                )}). Subscribe now to continue our services.`
              : user?.subscription?.type === 'paid' && user?.subcription?.days_remaining <= 3
              ? `Your subscription period is ending on (${fDate(
                  user?.subscription?.end_date
                )}). Subscribe again to continue our services.`
              : user?.subscription?.type === 'canceled'
              ? `Your subscription has been canceled . To continue our services, please resubscribe before this (${fDate(
                  user?.subscription?.end_date
                )}).`
              : user?.subscription?.type === 'expired' &&
                `Your subscription has expired on (${fDate(
                  user?.subscription?.end_date
                )}). Renew now to regain access to our services.`}
          </Alert>
          <Outlet />
        </MainStyle>
      </RootStyle>
    </>
  );
}
